import { lrwSessionStore, useTypedDispatch } from 'store';
import { useSelector } from 'react-redux';
import { LrwSessionDto } from 'api/planning';
import { useNavigationContext, useTableStateChange } from 'hooks';
import { LrwSessionsFilterValues, mapFiltersToQuery } from './LrwSessionsFilterBar';

export const useLrwSessions = () => {
  const { locationId } = useNavigationContext();
  const dispatch = useTypedDispatch();
  const tableState = useSelector(lrwSessionStore.selectors.tableState);
  const filters = useSelector(lrwSessionStore.selectors.filters);

  const { data, isFetching, isLoading } = lrwSessionStore.service.useGetLrwSessionsQuery(
    {
      tableState,
      filters,
      locationId: locationId!,
    },
    { skip: !locationId }
  );

  const { data: venues } = lrwSessionStore.service.useGetLrwSessionVenuesQuery(
    { locationId: locationId! },
    { skip: !locationId }
  );

  const onTableStateChange = useTableStateChange<LrwSessionDto>(
    lrwSessionStore.actions.updateTableState
  );

  const onFiltersApply = (values: LrwSessionsFilterValues) => {
    dispatch(lrwSessionStore.actions.applyFilters(mapFiltersToQuery(values)));
  };

  const hasActiveFilters = Object.values(filters).some((value) =>
    Array.isArray(value) ? value.length > 0 : value !== undefined
  );

  return {
    lrwSessions: data,
    isFetching,
    isLoading,
    onTableStateChange,
    tableState,
    venues: venues ?? [],
    onFiltersApply,
    hasActiveFilters,
  };
};
